import { SxStyles } from '../../../types';
import theme from '../../../theme';
import { getResponsiveSize } from '../../../utils';

export const MediaModalStyle: SxStyles = {
  mediaContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    height: '100%',
    '& .main-tabs': {
      pt: getResponsiveSize(16),
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.neutral?.grey8,
      borderRadius: `${theme.palette.propVars?.borderRadius} 0 0 ${theme.palette.propVars?.borderRadius}`,
      width: getResponsiveSize(320),
      '& .left-title': {
        display: 'flex',
        justifyContent: 'flex-start',
        width: '100%',
        pl: getResponsiveSize(16),
        mb: getResponsiveSize(8),
      },
      '& .MuiTabs-scroller': {
        pl: getResponsiveSize(8),
      },
      '& .MuiTabs-flexContainer': {
        height: '100%',
        justifyContent: 'start', // Center align the tabs
        alignItems: 'flex-start',
        width: '88%',

        '& .left-tab_container': {
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'nowrap',
          alignItems: 'flex-start',
          height: 'auto',
          backgroundColor: theme.palette.neutral?.grey8,
          borderRadius: `${theme.palette.propVars?.borderRadius} 0 0 ${theme.palette.propVars?.borderRadius}`,
        },
        '& .MuiButtonBase-root': {
          padding: '0px',
          minHeight: '0px',
          minWidth: '0px',
          mb: getResponsiveSize(12),
          alignSelf: 'start',
          textTransform: 'capitalize',
          py: getResponsiveSize(8),
          pl: getResponsiveSize(8),
          height: getResponsiveSize(30),
          width: '100%',
          justifyContent: 'flex-start',
          fontSize: getResponsiveSize(16),

          '& .left-tab_container-icon': {
            width: getResponsiveSize(16),
            height: getResponsiveSize(16),
          },
        },
        '& .Mui-selected': {
          color: '#494A4E',
          backgroundColor: '#D2D2D3',
          borderRadius: getResponsiveSize(12),
          pt: getResponsiveSize(4),
          pb: getResponsiveSize(4),
        },
      },
      '& .MuiDivider-root': {
        width: '80%',
        height: '1px',
        color: '#D2D2D3',
        display: 'flex',
        justifyContent: 'start',
        visibility: 'visible',
        opacity: '100',
      },
      '& .MuiTabs-indicator': {
        display: 'none',
      },
    },

    [theme.breakpoints.media?.laptop!]: {},
    [theme.breakpoints.media?.tablet!]: {},
  },
};
